[
  {
    "code": "SN-DK",
    "name": "Dakar"
  },
  {
    "code": "SN-DB",
    "name": "Diourbel"
  },
  {
    "code": "SN-FK",
    "name": "Fatick"
  },
  {
    "code": "SN-KL",
    "name": "Kaolack"
  },
  {
    "code": "SN-KD",
    "name": "Kolda"
  },
  {
    "code": "SN-LG",
    "name": "Louga"
  },
  {
    "code": "SN-MT",
    "name": "Matam"
  },
  {
    "code": "SN-SL",
    "name": "Saint-Louis"
  },
  {
    "code": "SN-TC",
    "name": "Tambacounda"
  },
  {
    "code": "SN-TH",
    "name": "Thiès"
  },
  {
    "code": "SN-ZG",
    "name": "Ziguinchor"
  }
]